import { config } from '@app/config';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { TokenGate } from './TokenGate';

interface Auth0ProviderWrapperProps {
  renderFn: (token: string | null) => ReactNode;
}

export function Auth0ProviderWrapper({ renderFn }: Auth0ProviderWrapperProps) {
  const history = useHistory();

  const onRedirectCallback = (appState?: AppState) => {
    // Handle redirect after authentication
    // appState.returnTo contains the redirect path from login
    const returnTo = appState?.returnTo || '/';
    history.push(returnTo);
  };

  return (
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: config.auth0.audience,
        scope: 'openid profile offline_access',
      }}
      // Enable refresh token rotation
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      // Store tokens in localStorage for persistence
      cacheLocation="localstorage"
      // Handle redirect after authentication
      onRedirectCallback={onRedirectCallback}
    >
      <TokenGate>{renderFn}</TokenGate>
    </Auth0Provider>
  );
}
